<template>
    <div class="page-wrapper">
        <delete-article-window
                :visible="deleteWindow.visible"
                :id="deleteWindow.id"
                :name="deleteWindow.name"
                @close-window="closeDeleteWindow"/>
        <Header/>
        <div class="wrapper">
            <div class="page admin-page">
                <div class="container col2">
                    <div class="container-left">
                        <UserMenu/>
                    </div>
                    <div class="container-right">
                        <div class="page-title cabinet-page-title visibility">
                            <span>Статьи</span>
                            <router-link :to="{name: 'AdminArticleEdit', params: {id: 'new'}}" class="add-link"><i
                                    class="fa fa-plus"></i>Добавить
                                статью
                            </router-link>
                        </div>

                        <div class="admin-articles-list"
                             v-for="(article, index) in articles">
                            <div class="admin-articles-item">
                                <router-link :to="{name: 'AdminArticleEdit', params: {id: article.id}}"
                                             class="admin-articles-link">
                                    <div class="articles-left">
                                        <div class="image"
                                             :style="{'background-image': `url(${getArticleImage(article)})`}"></div>
                                    </div>
                                    <div class="articles-right">
                                        <div class="title">{{ formatHeader(article.header, index) }}</div>
                                        <div class="date">{{ formatDate(article.date) }}</div>
                                        <div class="desc" v-html="article.textContent"/>
                                    </div>
                                </router-link>
                                <div class="icons">
                                    <router-link :to="{name: 'AdminArticleEdit', params: {id: article.id}}"
                                                 class="fa fa-pencil"
                                                 title="Редактировать статью"></router-link>
                                    <i class="fa fa-trash-o" title="Удалить статью"
                                       @click="showDeleteWindow(article)"></i>
                                </div>
                            </div>
                        </div>

                        <pagination
                                :currentPage="currentPage"
                                :totalPages="totalPages"
                                @load-page="loadArticles"/>
                    </div>
                </div>
            </div>
            <div class="page-buffer"></div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import UserMenu from '@/components/UserMenu';
    import Pagination from '@/components/Pagination';
    import DeleteArticleWindow from "@/components/window/DeleteArticleWindow";
    import moment from 'moment';
    import { uuid } from 'vue-uuid';

    const blankDeleteWindow = {
        visible: false,
        id: null,
        name: ''
    };

    export default {
        name: "AdminArticleList",

        components: {
            Header, Footer, UserMenu, Pagination, DeleteArticleWindow
        },

        data() {
            return {
                deleteWindow: Object.assign({}, blankDeleteWindow),

                articles: [],
                currentPage: 0,
                totalPages: 0,
                pageSize: 1,

                defaultArticleImage: require('@/image/default_article_image.jpg')
            }
        },

        async created() {
            let page = this.$route.query.page || 0;
            await this.loadArticles(page);
        },

        methods: {
            async loadArticles(page) {
                let articlesPage = await this.$store.dispatch('listArticles', [page || 0, 20]);
                if (!articlesPage)
                    return;

                this.articles = articlesPage.content;
                this.currentPage = articlesPage.pageable.pageNumber;
                this.totalPages = articlesPage.totalPages;
                this.pageSize = articlesPage.pageable.pageSize;
            },

            formatHeader(header, index) {
                let articleNum = this.pageSize * this.currentPage + index + 1;
                return `#${articleNum}|${header}`;
            },

            formatDate(date) {
                return moment(date).format("DD.MM.YYYY");
            },

            getArticleImage(article) {
                if (!!article.hasImage)
                    return process.env.VUE_APP_GLOBAL_URL + `/document/article-image/${article.id}?random=${uuid.v1()}` ;
                else
                    return this.defaultArticleImage;
            },

            showDeleteWindow(article) {
                Object.assign(this.deleteWindow, {
                    visible: true,
                    id: article.id,
                    name: article.header
                });
            },

            closeDeleteWindow(payload) {
                Object.assign(this.deleteWindow, blankDeleteWindow);
                if (!!payload.reload) {
                    this.loadArticles(0);
                }
            }
        },

        destroyed() {
            this.articles = [];
        }
    }
</script>